import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import HelpDeskServices from '../services/HelpDesk'
import Loader from '../component/Loader'
import ThemeTable from '../component/ThemeTable'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import { useNavigate } from 'react-router-dom'
import PrimaryOutLineButton from '../component/PrimaryOutLineButton'
import useScrollToTop from '../hooks/useScrollToTop'
import NoData from '../component/NoData'

const HelpDesk = () => {
    useScrollToTop()
    const [helpDeskData,setHelpDeskData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [noData,setNoData] = useState(false)
    useEffect(() => {
        const HelpDeskDataFetch = async()=>{
            try{
                const token = localStorage.getItem('access_token');
                const userInfo = JSON.parse(localStorage.getItem('userData'));
                const contactId = userInfo.dcm_contacts_id;
                const payload = {
                    "assign_to": parseInt(contactId),
                    "referanceId": "",
                    "get_list_for": parseInt(contactId),
                    "company_id": 0,
                    "by_ticket_status": "",
                    "by_ticket_type": "",
                    "request_id": ""
                }
                const HelpDeskDataResponse = await HelpDeskServices.allTickets(payload)
                
                if(HelpDeskDataResponse.apiStatus.message == 'success'){
                    const filteredData = HelpDeskDataResponse.tickets?.map((item,index)=>{
                        //Reply Button
                        const actionButton = 
                           <div className='btnWrapHelp'>
                            <PrimaryOutLineButton  outlinebuttonText ="Details" onClick={() => handleDetailsButtonClick(item.id, item.ticket_number)} />
                            
                            </div>;

                        let statusElement;
                        const status = item.status.toLowerCase();

                        if (status === 'open') {
                                statusElement = <span className="statusBox approvedTxt">Open</span>;
                        } else if (status === 'closed') {
                                statusElement = <span className="statusBox rejectedTxt">Closed</span>;
                        } else if (status === 'acknowledgement call done') {
                                statusElement = <span className="statusBox acccTxt">Acknowledgement call done</span>;
                        } else if (status === 'on hold') {
                                statusElement = <span className="statusBox holdTxt">On Hold</span>;
                        } else if (status === 'reopen') {
                                statusElement = <span className="statusBox reopenedTxt">Reopened</span>;
                        } else if (status === 'in progress') {
                                statusElement = <span className="statusBox acccTxt">In Progress</span>;
                        }

                         //TimeStamp Update
                        const dateTime = new Date(item.due_on);
                        const createdAt = new Date(item.created_at);
                        const formattedDateTime = dateTime.toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            second: 'numeric',
                            hour12: true,
                        });
                        const formattedCreatedDate = createdAt.toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            second: 'numeric',
                            hour12: true,
                        });
                        return{
                            
                            'Serial No': <div className='text-center'>{index+1}</div>,
                            'Query Category': item.category_name,
                            'Subcategory': item.sub_category_name,
                            'Order Id': item.orders[0]?.dcm_orders_id,
                            'Item Id': item.orders[0]?.dcm_order_items_id,
                            'Issue Summary': item.summary,
                            'Created Date': formattedCreatedDate,
                            // 'Due Date': formattedDateTime,
                            'Status': statusElement,
                            'Action' : actionButton,
                            
                        }
                    })
                    setHelpDeskData(filteredData)
                    setLoading(false)
                    setNoData(false)
                }
                else{
                    setLoading(false)
                    setNoData(true)
                }
            }
            catch(error){
                console.error("Help Desk data Fectch")

            }
        }
        HelpDeskDataFetch()
    },[])
    const navigate = useNavigate()
    const handleNewTicket = () =>{
       navigate(`/raise-ticket`)
    }
    const handleButtonClick = (ticketId, ticketNo) =>{
       navigate(`/help-desk-reply/${ticketId}/${ticketNo}`) ;

    }
    const handleDetailsButtonClick = (ticketId, ticketNo) =>{
        navigate(`/helpdesk-details/${ticketId}/${ticketNo}`) ;
    }
    
  return (
    <>
    {/* {loading && <Loader/> } */}
     <BreadCrumbSecttion
                pageTitle="Help Desk"
                currentPageName="Help Desk"
            />
            <section className='padTop50'>
                <Container>
                    <Col xs={12} lg={12}>
                        <div className="searchBoxBlock my-4">
                            
                            <Col xs={12} lg={3} className='align-right'>
                                <PrimaryGradientButton buttonText="Raise a new ticket" onClick={handleNewTicket}/>
                            </Col>
                        </div>
                    </Col>

                    <Row>
                        <Col xs = {12}>
                        {noData && <NoData/>}
                            <ThemeTable showLodeMoreBtn={false} data={helpDeskData}/>
                        {!noData && loading && <NoData title="fetching.." />}
                            
                        </Col>
                    </Row>
                    
                </Container>
            </section>
    </>
  )
}

export default HelpDesk